import { useQuery } from '@tanstack/vue-query'
import { computed, toValue } from 'vue'

import type { UseEntityQueryOptions } from '@/support/query/UseEntityQueryOptions.types'

import { callLocations } from '@/domains/locations/services'
import { STALE_TIMES } from '@/support/query/constants'
import { unwrapCollection } from '@/utils/collection-util/collectionUtil'

export const LOCATIONS_QUERY_KEY = ['locations'] as const

/**
 * Fetches all locations (page=-1) and caches them as low-churn reference data.
 * Locations are a small, stable set (~100 max) — no need for server-side search or pagination.
 */
export const useLocationsQuery = (options: UseEntityQueryOptions = {}) => {
  const query = useQuery({
    queryKey: [...LOCATIONS_QUERY_KEY],
    queryFn: async () => {
      const response = await callLocations().index({
        // Alphabetical, not the index's newest-first default: this is reference data for
        // pickers, where a person scans for a name they already have in mind.
        queryParams: { page: -1, sort: 'name' }
      })
      return unwrapCollection(response.data.value)
    },
    enabled: computed(() => toValue(options.enabled) ?? true),
    staleTime: STALE_TIMES.LOW_CHURN
  })

  return {
    ...query
  }
}
